<template>
  <div class="echarts">
    <div class="back">上级地图</div>
    <div class="returnImgDown">地图导出</div>
    <div style="width:100;height:100%;" ref="allMap"></div>
    <div class="tableBox">
      <div class="title">企业迁出排名</div>
      <!-- <ul class="down_title">
                <li class="active" @click="tableTab(0)">热点迁出</li>
                <li class="border"></li>
                <li @click="tableTab(2)">热点迁入</li>
            </ul> -->
      <ul class="down_title" style="position:relative;">
        <span
          style="height: 40px;line-height: 40px;color: #fff;display: inline-block;margin-left: 1.3%;"
          >迁出地：</span
        >
        <el-select
          v-model="fromCityValue"
          placeholder="请选择"
          size="mini"
          style="margin-top:4px;width:37%;"
        >
          <el-option
            v-for="(item, index) in fromCityList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <span
          style="height: 40px;line-height: 40px;color: #fff;display: inline-block;"
          >迁入地：</span
        >
        <el-select
          v-model="toCityValue"
          placeholder="请选择"
          size="mini"
          style="margin-top:4px;width:37%;"
        >
          <el-option
            v-for="(item, index) in toCityList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <span
          @click="ifLoginFn(1)"
          v-if="!loginInfo || !ifLgoin"
          style="width:100%;height:100%;position:absolute;top:0;left:0;background:#ccc;opacity:0;"
        ></span>
      </ul>
      <template>
        <!-- <el-table
                    v-if="tableDataIn.length && !activeTab"
                    :data="tableDataIn"
                    border
                    size="mini"
                    style="width: 100%;border:none;background: #052B4F;"
                    :row-style="getRowClass" :cell-style="getRowClass" :header-row-style="getRowClass" :header-cell-style="getRowClass">
                    <el-table-column
                        type="index"
                        label="排名"
                        width="50">
                    </el-table-column>
                    <el-table-column
                        width="180"
                        style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                        prop="city"
                        label="城市">
                    </el-table-column>
                    <el-table-column
                        prop="count"
                        label="迁徙量">
                        <template slot-scope="scope">
                            <span>{{ scope.row.count + '家' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="count"
                        label="迁徙热度">
                        <template slot-scope="scope">
                            <el-progress :text-inside="true" color="#177DE5" :show-text="false" type="line" :stroke-width="10" :percentage="(scope.row.count / scope.row.totalNum).toFixed(2) * 100" style="background:#054585;"></el-progress>
                        </template>
                    </el-table-column>
                </el-table> -->
        <el-table
          v-if="tableDataOut.length && activeTab"
          :data="tableDataOut"
          border
          size="mini"
          style="width: 100%;border:none;background: #052B4F;"
          :row-style="getRowClass"
          :cell-style="getRowClass"
          :header-row-style="getRowClass"
          :header-cell-style="getRowClass"
        >
          <el-table-column type="index" label="排名" width="50">
          </el-table-column>
          <el-table-column
            width="180"
            style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
            prop="city"
            label="城市"
          >
          </el-table-column>
          <el-table-column prop="count" label="迁徙量">
            <template slot-scope="scope">
              <span>{{ scope.row.count + "家" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="count" label="迁徙热度">
            <template slot-scope="scope">
              <el-progress
                :text-inside="true"
                color="#177DE5"
                :show-text="false"
                type="line"
                :stroke-width="10"
                :percentage="
                  (scope.row.count / scope.row.totalNum).toFixed(2) * 100
                "
                style="background:#054585;"
              ></el-progress>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <!--点击返回 -->
    <!-- <div class="mapChoose">
            <span v-for="(item,index) in parentInfo" :key="item.code">
                <span class="title" @click="chooseArea(item,index)">{{item.cityName=='全国'?'中国':item.cityName}}</span>
                <span class="icon" v-show="index+1!=parentInfo.length">></span>
            </span>
        </div> -->
  </div>
</template>

<script>
import echarts from "echarts";
import resize from "./mixins/resize";
import _tmpData from "@/view/migrationMap/data.js";
import magic from "@/../static/common/magic.js";
export default {
  name: "allMap",
  mixins: [resize],
  props: ["loginInfo"],
  data() {
    return {
      myCharts: null,
      geoJson: {
        features: []
      },
      parentInfo: [
        {
          cityName: "全国",
          code: 100000
        }
      ],
      inLineData: {}, //每个年份下迁进线的数据
      outLineData: {}, //每个年份下迁进线的数据
      tableDataIn: {},
      tableDataOut: {},
      migrationIn: {}, //表格部分--热点迁入
      migrationOut: {}, //表格部分--热点迁出
      activeTab: true, //切换表格里的tab参数
      inTimeTitle: ["2019-09", "2020-09"], //时间标签
      outTimeTitle: ["2019-09", "2020-09"], //时间标签
      fromCityList: [], //起始城市列表--下拉框
      toCityList: [], //终点城市列表--下拉框
      fromCityValue: "",
      toCityValue: "",
      ifLgoin: false
    };
  },
  watch: {
    //起始城市下拉框选中数据
    fromCityValue(newVal, oldVal) {
      let _this = this;

      _this.inLineData = [];
      _this.outLineData = [];

      if (_this.parentInfo.length == 1) {
        _this.getGeoJson(
          _this.parentInfo[_this.parentInfo.length - 1].code,
          _this.parentInfo[_this.parentInfo.length - 1].cityName,
          "",
          newVal,
          _this.toCityValue
        );
      }

      if (_this.parentInfo.length == 2) {
        _this.getGeoJson(
          _this.parentInfo[_this.parentInfo.length - 1].code,
          _this.parentInfo[_this.parentInfo.length - 1].cityName,
          "province",
          newVal,
          _this.toCityValue
        );
      }

      if (_this.parentInfo.length == 3) {
        _this.getGeoJson(
          _this.parentInfo[_this.parentInfo.length - 1].code,
          _this.parentInfo[_this.parentInfo.length - 1].cityName,
          "city",
          newVal,
          _this.toCityValue
        );
      }
    },
    toCityValue(newVal, oldVal) {
      let _this = this;

      _this.inLineData = [];
      _this.outLineData = [];

      if (_this.parentInfo.length == 1) {
        _this.getGeoJson(
          _this.parentInfo[_this.parentInfo.length - 1].code,
          _this.parentInfo[_this.parentInfo.length - 1].cityName,
          "",
          _this.fromCityValue,
          newVal
        );
      }

      if (_this.parentInfo.length == 2) {
        _this.getGeoJson(
          _this.parentInfo[_this.parentInfo.length - 1].code,
          _this.parentInfo[_this.parentInfo.length - 1].cityName,
          "province",
          _this.fromCityValue,
          newVal
        );
      }

      if (_this.parentInfo.length == 3) {
        _this.getGeoJson(
          _this.parentInfo[_this.parentInfo.length - 1].code,
          _this.parentInfo[_this.parentInfo.length - 1].cityName,
          "city",
          _this.fromCityValue,
          newVal
        );
      }
    },
    activeTab(newVal, oldVal) {
      //监测表格的切换展示地图的输入还是输出
      this.inLineData = [];
      this.outLineData = [];

      if (this.parentInfo.length == 1) {
        this.getGeoJson(
          this.parentInfo[this.parentInfo.length - 1].code,
          this.parentInfo[this.parentInfo.length - 1].cityName
        );
      }

      if (this.parentInfo.length == 2) {
        this.getGeoJson(
          this.parentInfo[this.parentInfo.length - 1].code,
          this.parentInfo[this.parentInfo.length - 1].cityName,
          "province"
        );
      }

      if (this.parentInfo.length == 3) {
        this.getGeoJson(
          this.parentInfo[this.parentInfo.length - 1].code,
          this.parentInfo[this.parentInfo.length - 1].cityName,
          "city"
        );
      }
    }
  },
  mounted() {
    this.getGeoJson(100000);
    this.ifLoginFn();
    // this.tableTab(0);

    $('<div class="back">返 回</div>').appendTo($("#chart-panel"));

    // $('.back').css({
    //     'position': 'absolute',
    //     'left': '25px',
    //     'top': '25px',
    //     'color': 'rgb(179, 239, 255)',
    //     'font-size': '16px',
    //     cursor: 'pointer',
    //     'z-index': '100'
    // })

    $(".back").click(() => {
      if (this.parentInfo.length === 1) {
        return;
      }
      this.parentInfo.pop();

      this.fromCityValue = "";
      this.toCityValue = "";
      this.fromCityList = [];
      this.toCityList = [];

      if (this.parentInfo.length === 2) {
        this.getGeoJson(
          this.parentInfo[this.parentInfo.length - 1].code,
          this.parentInfo[this.parentInfo.length - 1].cityName,
          "province"
        );
      }

      if (this.parentInfo.length === 1) {
        this.getGeoJson(this.parentInfo[this.parentInfo.length - 1].code);
      }
    });

    $(".el-input--mini .el-input__inner").css({
      background: "#023261",
      border: "1px solid rgb(8, 57, 106)",
      color: "#fff"
    });
  },
  methods: {
    ifLoginFn(num = 0) {
      let _this = this;
      magic.loginOrRights(2).then(res => {
        if (!res) {
          num ? _this.$message.error("请您登录！") : "";
          _this.ifLgoin = false;
          return;
        }
        if (res && res.rights == 0) {
          num ? _this.$message.error("您没有权限！") : "";
          _this.ifLgoin = false;
          return;
        }
        _this.ifLgoin = true;
      });
    },
    //table切换函数
    tableTab(num) {
      // $('.down_title li').removeClass('active')
      // $('.down_title li').eq(num).attr('class','active');
      this.activeTab = !this.activeTab;

      $(".el-progress-bar__outer").css({
        "background-color": "rgba(5, 43, 79, 0.3)",
        border: "1px solid #177DE5",
        "border-radius": "2px"
      });
      $(".el-progress-bar__inner").css({
        "border-radius": "2px",
        margin: "1px",
        height: "83%"
      }); //#177DE5
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background: #052B4F;border:1px solid #08396A;font-size: 14px;height:38px;color:#DFECF7;";
    },
    //获取地图数据
    getMyData(selectLevel, name, fromName = "", toName = "") {
      let _this = this;
      return new Promise(function(resolve, reject) {
        let params = {
          selectLevel: selectLevel, //默认全国的是'',省级的是province
          selectName: name, //默认全国的是'',省级的是province某某省
          fromName: fromName,
          toName: toName
        };

        api.mmap_getDevelopData(params).then(res => {
          let data = res.data;

          // console.log(data,'data')

          resolve(data);
        });
      });
    },
    getGeoJson(
      adcode,
      selectName = "",
      selectLevel = "",
      fromName = "",
      toName = ""
    ) {
      let that = this;

      // 定义加载 JSON 数据的方法
      const loadJson = (filePath, callback, failCallback) => {
        $.getJSON(filePath)
          .done(data => {
            // console.log(`Loaded ${filePath}`);
            callback(data);
          })
          .fail(() => {
            console.error(`Failed to load ${filePath}`);
            if (typeof failCallback === "function") failCallback();
          });
      };

      // 定义加载逻辑，优先加载 full 文件
      const tryLoadMapData = adcode => {
        const fullFilePath = `@/../static/plugins/chinese-map/static/Amapfor2024/${adcode}_full.json`;
        const normalFilePath = `@/../static/plugins/chinese-map/static/Amapfor2024/${adcode}.json`;

        // 先尝试加载 full 文件
        loadJson(
          fullFilePath,
          data => {
            // 如果加载 full 文件成功，直接使用数据
            // console.log(`Loaded ${adcode}_full.json`);
            that.geoJson.features = that.validateFeatures(data.features || []);
            that.populateCityList(that.geoJson.features, selectLevel);
          },
          () => {
            // 如果加载 full 文件失败，尝试加载普通文件
            loadJson(normalFilePath, data => {
              // console.log(`Loaded ${adcode}.json`);
              that.geoJson.features = that.validateFeatures(
                data.features || []
              );
              that.populateCityList(that.geoJson.features, selectLevel);
            });
          }
        );
      };
      tryLoadMapData(adcode);
      // 加载不同地图数据的逻辑
      // if (adcode === "100000") {
      //   // 如果是全国地图，直接加载 100000_full.json
      //   tryLoadMapData("100000");
      // } else {
      //   // 对于其他地区，尝试加载 full 文件，否则加载普通文件
      //   tryLoadMapData(adcode);
      // }

      // 获取当前地图数据值
      that.getMyData(selectLevel, selectName, fromName, toName).then(res => {
        that.outLineData = res.outLineData; // 每个年份下迁出线的数据
        that.migrationOut = res.migrationOut; // 表格部分--热点迁出
        that.outTimeTitle = res.outTimeTitle; // 迁出时间标签

        setTimeout(() => {
          // 对表格进度条的样式
          $(".el-progress-bar__outer").css({
            "background-color": "rgba(5, 43, 79, 0.3)",
            border: "1px solid #177DE5",
            "border-radius": "2px"
          });
          $(".el-progress-bar__inner").css({
            "border-radius": "2px",
            margin: "1px",
            height: "83%"
          });
        }, 0);

        that.getMapData();
      });
    },
    // 新增的方法，用于验证 features 数据
    validateFeatures(features) {
      // 遍历每个 feature，检查数据的有效性
      return features.filter(feature => {
        // 检查 adcode 是否为有效数字（例如不应该包含字母）且 name 不为空
        const adcode = feature.properties.adcode || "";
        const name = feature.properties.name || "";

        const isValidAdcode = /^[0-9]+$/.test(adcode); // 仅允许纯数字的 adcode
        const isValidName = name.trim().length > 0; // 确保名称非空

        if (!isValidAdcode || !isValidName) {
          console.warn(
            `Invalid data detected and skipped: ${JSON.stringify(
              feature.properties
            )}`
          );
          return false; // 如果数据无效，则跳过
        }
        return true; // 仅保留有效的数据
      });
    },
    // 新增的方法，用于处理城市列表的填充逻辑
    populateCityList(features, selectLevel) {
      // console.log(features);

      let that = this;

      if (features.length > 0) {
        that.fromCityList.push({ value: "", label: "全部" });
        that.toCityList.push({ value: "", label: "全部" });

        features.forEach(feature => {
          const name = feature.properties.name;
          let displayName = name;

          // 根据名称判断处理不同的省市名称
          if (!selectLevel) {
            if (name.includes("市")) {
              displayName = name === "上海市" ? name : name.slice(0, -1);
            } else if (name.includes("省")) {
              displayName = name.slice(0, -1);
            } else if (name.includes("内蒙古自治区")) {
              displayName = name.slice(0, -3);
            } else if (name.includes("特别行政区")) {
              displayName = name.slice(0, -5);
            } else if (name.includes("广西壮族自治区")) {
              displayName = name.slice(0, -5);
            } else if (name.includes("西藏自治区")) {
              displayName = name.slice(0, -3);
            } else if (name.includes("宁夏回族自治区")) {
              displayName = name.slice(0, -5);
            } else if (name.includes("新疆维吾尔自治区")) {
              displayName = name.slice(0, -6);
            }
          }

          // 填充城市列表
          that.fromCityList.push({ value: displayName, label: displayName });
          that.toCityList.push({ value: displayName, label: displayName });
        });
      }
    },
    //获取数据
    getMapData() {
      let mapData = {},
        pointData = {};
      let _title = this.activeTab ? this.outTimeTitle : this.inTimeTitle;
      // console.log(this.geoJson, "this.geoJsonthis.geoJsonthis.geoJson");

      _title.forEach(item => {
        mapData[item] = [];
        pointData[item] = [];
        this.geoJson.features.forEach(j => {
          let value = Math.random() * 3000;
          // let value = 0;
          mapData[item].push({
            name: j.properties.name,
            value: 0,
            cityCode: j.properties.adcode
          });

          pointData[item].push({
            name: j.properties.name,
            value: [j.properties.center[0], j.properties.center[1], 0],
            cityCode: j.properties.adcode
          });
        });
        mapData[item] = mapData[item].sort(function(a, b) {
          return b.value - a.value;
        });
      });

      this.initEcharts(mapData, pointData);
    },
    initEcharts(mapData, pointData) {
      let _this = this;
      this.myChart = echarts.init(this.$refs.allMap);
      if (this.parentInfo.length === 1) {
        echarts.registerMap("china", this.geoJson); //注册
      } else {
        echarts.registerMap("map", this.geoJson); //注册
      }
      var option = {
        timeline: {
          data: _this.activeTab ? _this.outTimeTitle : _this.inTimeTitle,
          axisType: "category",
          autoPlay: false,
          playInterval: 6000,
          left: "10%",
          right: "10%",
          bottom: "2%",
          width: "80%",
          currentIndex: Object.keys(_this.migrationOut).length - 1,
          label: {
            normal: {
              textStyle: {
                color: "rgb(179, 239, 255)"
              }
            },
            emphasis: {
              textStyle: {
                color: "#fff"
              }
            }
          },
          symbolSize: 10,
          lineStyle: {
            color: "#8df4f4"
          },
          checkpointStyle: {
            borderColor: "#8df4f4",
            color: "#0360B9",
            borderWidth: 2
          },
          controlStyle: {
            showNextBtn: true,
            showPrevBtn: true,
            normal: {
              color: "#53D9FF",
              borderColor: "#53D9FF"
            },
            emphasis: {
              color: "rgb(58,115,192)",
              borderColor: "rgb(58,115,192)"
            }
          }
        },
        baseOption: {
          animation: true,
          animationDuration: 900,
          animationEasing: "cubicInOut",
          animationDurationUpdate: 900,
          animationEasingUpdate: "cubicInOut",
          tooltip: {
            trigger: "axis"
          },
          grid: {
            right: "2%",
            top: "12%",
            bottom: "8%",
            width: "20%"
          },
          geo: {
            map: this.parentInfo.length === 1 ? "china" : "map",
            zoom: 1.1,
            roam: true,
            center:
              this.parentInfo.length === 1
                ? ["118.83531246", "32.0267395887"]
                : false,

            label: {
              normal: {
                show: true,
                color: "rgb(249, 249, 249)", //省份标签字体颜色
                formatter: p => {
                  switch (p.name) {
                    case "内蒙古自治区":
                      p.name = "内蒙古";
                      break;
                    case "西藏自治区":
                      p.name = "西藏";
                      break;
                    case "新疆维吾尔自治区":
                      p.name = "新疆";
                      break;
                    case "宁夏回族自治区":
                      p.name = "宁夏";
                      break;
                    case "广西壮族自治区":
                      p.name = "广西";
                      break;
                    case "香港特别行政区":
                      p.name = "香港";
                      break;
                    case "澳门特别行政区":
                      p.name = "澳门";
                      break;
                    default:
                      break;
                  }
                  return p.name;
                }
              },
              emphasis: {
                show: true,
                color: "#f75a00"
              }
            },
            itemStyle: {
              normal: {
                areaColor: "#24CFF4",
                borderColor: "#53D9FF",
                borderWidth: 1.3,
                shadowBlur: 15,
                shadowColor: "rgb(58,115,192)",
                shadowOffsetX: 7,
                shadowOffsetY: 6
              },
              emphasis: {
                areaColor: "#8dd7fc",
                borderWidth: 1.6,
                shadowBlur: 25
              }
            }
          }
        },
        options: []
      };

      var color = ["#3ed4ff", "#ffa022", "#a6c84c"];
      var planePath =
        "path://M.6,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705";

      pushData(this);
      function pushData(_this) {
        let _title = _this.activeTab ? _this.outTimeTitle : _this.inTimeTitle;
        let _num = 0;
        _title.forEach(item => {
          var xData = [],
            yData = [];
          var min = mapData[item][mapData[item].length - 1].value;
          var max = mapData[item][0].value;
          if (mapData[item].length === 1) {
            min = 0;
          }
          mapData[item].forEach(c => {
            xData.unshift(c.name);
            yData.unshift(c.value);
          });

          _num++;
          if (_num == 1) {
            // _this.tableDataIn = {};
            _this.tableDataOut = {};
            // _this.tableDataIn = _this.migrationIn[item];
            // _this.tableDataOut = _this.migrationOut[item];
            _this.tableDataOut =
              _this.migrationOut[Object.keys(_this.migrationOut).pop()];
          }

          option.options.push({
            series: [
              {
                name: item + "企业迁徙分析",
                type: "map",
                geoIndex: 0,
                map: _this.parentInfo.length === 1 ? "china" : "map",
                roam: true,
                zoom: 1.3,
                label: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: false
                  }
                },
                data: mapData[item]
              },
              {
                name: " Top10",
                type: "lines",
                zlevel: 1,
                tooltip: {
                  trigger: "item",
                  formatter: p => {
                    let val = p.value;
                    if (p.name == "南海诸岛") return;
                    if (window.isNaN(val)) {
                      val = 0;
                    }
                    let txtCon =
                      "<div style='text-align:left'> " +
                      p.data.fromName +
                      " -> " +
                      p.data.toName +
                      "</div>";
                    return txtCon;
                  }
                },
                effect: {
                  show: true,
                  period: 6,
                  trailLength: 0.7,
                  color: "#fff",
                  symbolSize: 2
                },
                lineStyle: {
                  normal: {
                    color: color[0],
                    width: 0,
                    curveness: 0.2
                  }
                },
                data: _this.activeTab
                  ? _this.outLineData
                    ? _this.outLineData[item]
                    : []
                  : _this.inLineData
                  ? _this.inLineData[item]
                  : []
              },
              {
                name: " Top10",
                type: "lines",
                zlevel: 2,
                tooltip: {
                  trigger: "item",
                  formatter: p => {
                    let val = p.value;
                    if (p.name == "南海诸岛") return;
                    if (window.isNaN(val)) {
                      val = 0;
                    }
                    let txtCon =
                      "<div style='text-align:left'> " +
                      p.data.fromName +
                      " -> " +
                      p.data.toName +
                      "</div>";
                    return txtCon;
                  }
                },
                effect: {
                  show: true,
                  period: 6,
                  trailLength: 0,
                  symbol: planePath,
                  symbolSize: 15
                },
                lineStyle: {
                  normal: {
                    color: color[1],
                    width: 1,
                    opacity: 0.4,
                    curveness: 0.2
                  }
                },
                data: _this.activeTab
                  ? _this.outLineData
                    ? _this.outLineData[item]
                    : []
                  : _this.inLineData
                  ? _this.inLineData[item]
                  : []
              },
              {
                name: "散点",
                type: "effectScatter",
                coordinateSystem: "geo",
                rippleEffect: {
                  brushType: "fill"
                },
                itemStyle: {
                  normal: {
                    color: "#F4E925",
                    shadowBlur: 10,
                    shadowColor: "#333"
                  }
                },
                data: pointData[item],
                // symbolSize: 8,
                symbolSize: function(val) {
                  let value = val[2];
                  if (value == max) {
                    return 8;
                  }
                  return 8;
                },
                showEffectOn: "render" //加载完毕显示特效
              }
            ]
          });

          // console.log( _this.tableDataOut,' _this.tableDataOut')
        });
        _this.myChart.setOption(option, true);
      }

      this.myChart.off("click");
      this.myChart.on("click", params => {
        if (
          (params.componentSubType == "effectScatter" ||
            params.componentSubType == "map") &&
          params.data
        ) {
          if (
            this.parentInfo[this.parentInfo.length - 1].code ==
            params.data.cityCode
          ) {
            return;
          }

          magic.loginOrRights(2).then(res => {
            if (!res) {
              _this.$message.error("请您登录！");
              return;
            }
            if (res && res.rights == 0) {
              _this.$message.error("您没有权限！");
              return;
            }

            if (_this.parentInfo.length < 3) {
              let data = params.data;
              // console.log(data);

              _this.parentInfo.push({
                cityName: data.name,
                code: data.cityCode
              });

              option.options = [];
              _this.inLineData = [];
              _this.outLineData = [];
              _this.fromCityValue = "";
              _this.toCityValue = "";

              pushData(_this);

              if (_this.parentInfo.length == 2 && data.cityCode && data.name) {
                _this.getGeoJson(data.cityCode, data.name, "province");
              }

              if (_this.parentInfo.length == 3 && data.cityCode && data.name) {
                _this.getGeoJson(data.cityCode, data.name, "city");
              }
            }

            // 埋点
            try {
              //LogCollection.contents["key"]="value";
              //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
              //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
              LogCollection.send(9);
            } catch (e) {}
          });
        }
      });

      //点击导出地图按钮导出图片
      $(".returnImgDown").off("click");
      $(".returnImgDown").on("click", () => {
        magic.loginOrRights(2).then(res => {
          if (!res) {
            _this.$message.error("请您登录！");
            return;
          }
          if (res && res.rights == 0) {
            _this.$message.error("您没有权限！");
            return;
          }

          var img = new Image();
          img.src = this.myChart.getDataURL({
            type: "png",
            pixelRatio: 2, //放大2倍
            backgroundColor: "#fff"
          });

          img.onload = function() {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            var dataURL = canvas.toDataURL("image/png");

            var a = document.createElement("a");
            // 创建一个单击事件
            var event = new MouseEvent("click");
            // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
            a.download = "迁徙分析.png" || "迁徙分析";
            // 将生成的URL设置为a.href属性
            a.href = dataURL;
            // 触发a的单击事件
            a.dispatchEvent(event);
          };
        });
      });
      this.myChart.on("timelinechanged", function(a, b) {
        let curIndex = a.currentIndex;
        let tmp_out_key = [];
        let tmp_in_key = [];
        for (var key in _this.migrationOut) {
          tmp_out_key.push(_this.migrationOut[key]);
        }
        // for (var key in _this.migrationIn) {
        //     tmp_in_key.push(_this.migrationIn[key])
        // }
        _this.tableDataIn = {};
        _this.tableDataOut = {};
        // _this.tableDataIn = tmp_in_key[curIndex];
        _this.tableDataOut = tmp_out_key[curIndex];
      });
    },
    //选择切换市县
    chooseArea(val, index) {
      if (this.parentInfo.length === index + 1) {
        return;
      }
      this.parentInfo.splice(index + 1);
      this.getGeoJson(this.parentInfo[this.parentInfo.length - 1].code);
    }
  }
};
</script>
<style lang="less" scoped>
.echarts {
  width: 100%;
  height: 100%;
  position: relative;
}
.tableBox {
  position: absolute;
  top: 95px;
  right: 20px;
  width: 28%;
  height: 64%;
  background: #052b4f;
  border: 1px solid #08396a;
  // overflow-y:scroll;
  .title {
    width: 100%;
    height: 44px;
    background: rgba(23, 127, 232, 0.98);
    border: 1px solid #08396a;
    border-radius: 2px;
    text-align: center;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #dfecf7;
    line-height: 44px;
  }
  .down_title {
    width: 99.4%;
    height: 38px;
    background: rgba(5, 43, 79, 0.8);
    border: 1px solid #08396a;
    overflow: hidden;
    cursor: pointer;
    li {
      width: 49.7%;
      height: 38px;
      float: left;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #6d84a2;
      line-height: 38px;
      text-align: center;
      &.active {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #218efe;
      }
      &.border {
        width: 1px;
        height: 20px;
        background: #08396a;
        margin-top: 9px;
      }
    }
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background: #08396a;
  }
}

.returnImgDown {
  width: 96px;
  height: 32px;
  background: rgba(223, 236, 247, 0);
  border: 1px solid #3c98f5;
  border-radius: 2px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3c98f5;
  line-height: 32px;
  text-align: center;
  margin-left: 11px;
  cursor: pointer;
  position: absolute;
  top: 25px;
  right: 25px;
  z-index: 10000;
}
.back {
  width: 96px;
  height: 32px;
  background: rgba(223, 236, 247, 0);
  border: 1px solid #3c98f5;
  border-radius: 2px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3c98f5;
  line-height: 32px;
  text-align: center;
  margin-left: 11px;
  cursor: pointer;
  position: absolute;
  top: 25px;
  left: 25px;
  z-index: 10000;
}

.mapChoose {
  position: absolute;
  left: 20px;
  top: 55px;
  color: #eee;

  .title {
    padding: 5px;
    border-top: 1px solid rgba(147, 235, 248, 0.8);
    border-bottom: 1px solid rgba(147, 235, 248, 0.8);
    cursor: pointer;
  }

  .icon {
    font-family: "simsun";
    font-size: 25px;
    margin: 0 11px;
  }
}
.el-input--mini .el-input__inner {
  background: #023261 !important;
  border: 0 !important;
  color: #fff !important;
  height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/allMap/index.vue